import { useState } from 'react';
import { useCouponIssueHistoryDetailQuery } from '../queries/coupon/useCouponIssueHistoryDetailQuery';

const INITIAL_FILTER_OPTION = { isUsed: null };
const INITIAL_SORT_OPTION = { userId: 'descend' as const, couponId: null };
const INITIAL_PAGINATION = { pageNum: 0, pageSize: 20 };

export const useCouponIssueHistoryDetail = (couponIssueHistoryId: number) => {
  const [filterOption, setFilterOption] = useState<Record<string, unknown>>(INITIAL_FILTER_OPTION);
  const [sortOption, setSortOption] = useState<Record<string, unknown>>(INITIAL_SORT_OPTION);
  const [itemListPagination, setItemListPagination] = useState(INITIAL_PAGINATION);

  const { data, isLoading, error } = useCouponIssueHistoryDetailQuery({
    couponIssueHistoryId,
    filterOption,
    sortOption,
    pagination: itemListPagination,
  });

  const onItemListChange = (option: Record<string, unknown>) => {
    if (option.filterOption) setFilterOption(option.filterOption as Record<string, unknown>);
    if (option.sortOption) setSortOption(option.sortOption as Record<string, unknown>);
    if (option.pagination) {
      const pag = option.pagination as { pageNum: number; pageSize: number };
      setItemListPagination(pag);
    }
  };

  return {
    couponIssueHistoryInfo: data?.couponIssueHistoryInfo ?? {},
    couponIssueHistoryItemList: data?.couponIssueHistoryItemList?.list ?? [],
    itemListFilterOption: data?.couponIssueHistoryItemList?.filterOption ?? INITIAL_FILTER_OPTION,
    itemListSortOption: data?.couponIssueHistoryItemList?.sortOption ?? INITIAL_SORT_OPTION,
    itemListPagination: data?.couponIssueHistoryItemList?.pagination ?? { ...INITIAL_PAGINATION, pages: 1 },
    isLoading,
    error,
    onItemListChange,
  };
};
